/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Event_NumberInputs */

const en_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select event number`)
};

const fr_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le numero d'evenement`)
};

const de_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisnummer auswählen`)
};

const it_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il numero dell'evento`)
};

const ru_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите номер мероприятия`)
};

const es_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el número de evento`)
};

const zh_cn2_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择事件编号`)
};

const ja_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント番号を選択`)
};

const hi_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट नंबर चुनें`)
};

const pt_pt2_editor_select_event_number = /** @type {(inputs: Editor_Select_Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o número do evento`)
};

/**
* | output |
* | --- |
* | "Select event number" |
*
* @param {Editor_Select_Event_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_number = /** @type {((inputs?: Editor_Select_Event_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_event_number(inputs)
	if (locale === "de") return de_editor_select_event_number(inputs)
	if (locale === "it") return it_editor_select_event_number(inputs)
	if (locale === "ru") return ru_editor_select_event_number(inputs)
	if (locale === "es") return es_editor_select_event_number(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_event_number(inputs)
	if (locale === "ja") return ja_editor_select_event_number(inputs)
	if (locale === "hi") return hi_editor_select_event_number(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_event_number(inputs)
	return en_editor_select_event_number(inputs)
});